import React from 'react'

const About = () => {
  return (
    <div className='about_container'>
      <p className="heading">About Us</p>
      <p className="sub_heading">
        Welcome to MemoWrite, the ultimate platform for organizing your thoughts and ideas. Whether you're a student, professional, or just someone who loves to jot down notes, MemoWrite is the perfect tool for you to keep track of your ideas, thoughts, and to-do lists in one place.
      </p>
    </div>
  )
}

export default About
